<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1">雷达图</el-radio>
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <div class="timesheet" style="padding:20px">
        <el-radio-group v-model="timeRadio" @change="changeRadio">
          <el-radio-button :label="1">7天</el-radio-button>
          <el-radio-button :label="2">30天</el-radio-button>
        </el-radio-group>
      </div>
      <div ref="modularChild13" class="echarts"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import * as echarts from "echarts"
export default {
  name: 'modularChild12',
  props: ['socUserName'],  
  data() {
    return {
      timeRadio: 1,
      value1: '',
      value2: [],
      radio: 1,
      chartsi: null,
      chartLoading: false,
      optioni: {
        title: {
          // text: "基础雷达图"
        },
        tooltip: {},
        legend: {
          show: false,
          type: 'scroll',
          orient: 'vertical',
          left: 10
          // data: ["高风险情况", "低风险情况"],
          // orient: 'vertical',
          // left: 'left',
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: "#fff",
              backgroundColor: "#999",
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator: [
            { name: 'loopholeScan'},
            { name: 'securityEvent'},
            { name: 'majorOperation'},
            { name: 'networkIntrusion'},
            { name: 'malice'}
          ]
        },
        series: [
          {
            name: "网络整体安全状态评分",
            type: "radar",
            // areaStyle: {normal: {}},
            data: [
              // {
              //   value: [4300, 10000, 28000, 35000, 50000, 19000],
              //   name: "高风险情况"
              // },
              // {
              //   value: [5000, 14000, 28000, 31000, 42000, 21000],
              //   name: "低风险情况"
              // }
            ]
          }
        ]
      },
    endTime: "",
    username: "",
    startTime: ""   
    };
  },
  methods: {
    getTime(socUserName){
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true;      
      var nowdate = new Date();
      var nowdate = new Date()
      var startTime = nowdate.setDate(nowdate.getDate() - 6)
      var endTime = Date.parse(new Date())
      if (this.timeRadio === 2) {
        nowdate = new Date()
        startTime = nowdate.setDate(nowdate.getDate() - 29)
        endTime = Date.parse(new Date())
      }
      let params = {
        "endTime": endTime,
        "username": socUserName,
        "startTime": startTime
      }
      this.getData(params)
    },
    clickBtn(socUserName) {     
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true; 
      let params = {
        'endTime': this.value2 ? Date.parse(this.value2[1]) : '',
        'username': socUserName,
        'startTime': this.value2 ? Date.parse(this.value2[0]) : ''
      }     
      this.getData(params)
    },
    getData(params) {
      this.$http.post(`/front/consumer/order/soc/interface/queryOverallNetworkSecurityStatusScore`, params)
        .then(data => {           
          if (data && data.status === 200 && data.data.code === 0) {
            let res = this.formatterData(data.data.data)
            this.chartsi.setOption(this.optioni)
            // this.dataList = res
          } else {
            this.$message.error(data.result.msg)
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
      this.chartsi.setOption(this.optioni)
    },
    formatterData(data) {
      // this.optioni.radar.indicator = []
      this.optioni.series[0].data = []
      if (data.lable && data.lable.length) {
        this.optioni.radar.indicator = data.lable.map(item => {
          return {
            name: item,
            min: 0
          }
        })
      }
      if (data.series && data.series.length) {
        this.optioni.series[0].data = data.series
      }
      return this.optioni
    },
    changeRadio () {
      this.getTime()
    }
  },
  mounted() {
    let charti = echarts.getInstanceByDom(this.$refs["modularChild13"]);
    if (charti === undefined) {
      this.chartsi = echarts.init(this.$refs["modularChild13"]);
      this.$once("hook:beforeDestroy", function() {
        echarts.dispose(this.chartsi);
      });
    }
    this.getTime();
  }
};
</script>

<style lang="scss" scoped>
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 100px;
      margin: 0 auto;
    }
  }
  .echarts {
    height: calc(100vh - 370px);
    min-height: 450px;
  }
}
</style>
